<script setup>
import CFTicketModalInner from '#modules/support/components/Ticket/CFTicketModalInner.vue';
import { useTicketStore } from '#modules/support/stores/ticket.store.js';
import CFButton from '@/ui/Button/CFButton.vue';
import TicketStartStep from '#modules/support/components/Ticket/Steps/TicketStartStep.vue';
import SupportOptionsStep from '#modules/support/components/Ticket/Steps/SupportOptionsStep.vue';
import { useBusinessHours } from '#modules/support/composables/useBusinessHours.js';
import CFIcon from '@/ui/Icon/CFIcon.vue';
import appConfig from '@/app/config/app.js';

const ticketStore = useTicketStore();

const { isInsideBusinessHours } = useBusinessHours();

const callPhoneNumber = () => {
    window.open('tel:+310407114496', '_self');
};

const goToTicketStartStep = () => {
    ticketStore.setComponent(TicketStartStep, SupportOptionsStep);
};

const goToDocumentation = () => {
    window.open('https://docs.cyberfusion.io/', '_blank');
};
</script>

<template>
    <CFTicketModalInner :title="$t('support.overview_modal_title')">
        <p class="mb-6 text-sm">{{ $t('support.overview_modal_description') }}</p>

        <div class="mb-2 grid-cols-2 gap-2 md:grid">
            <div class="col-span-1 mb-4 flex flex-col items-center bg-white px-7 pt-3 pb-5 md:mb-0">
                <div
                    class="h-1.5 w-1.5 rounded-full"
                    :class="isInsideBusinessHours() ? 'bg-green-500' : 'bg-red-500'"
                ></div>
                <h3 class="mt-1 text-xs font-bold">{{ $t('general.question') }}</h3>
                <CFIcon
                    name="conversation-question-warning"
                    size="20"
                    class="mt-5 mb-2"
                />
                <p class="text-center text-xs leading-snug">
                    {{ $t('support.question_description') }}
                </p>
                <p class="text-2xs mt-2 mb-3 text-center text-green-400">
                    {{ $t('general.free') }}
                </p>
                <CFButton
                    size="sm"
                    variant="outline"
                    type="button"
                    class="mt-auto"
                    @click="goToTicketStartStep"
                >
                    {{ $t('button.ask_question') }}
                </CFButton>
            </div>

            <div class="col-span-1 mb-4 flex flex-col items-center bg-white px-7 pt-3 pb-5 md:mb-0">
                <div class="h-1.5 w-1.5 rounded-full bg-green-500"></div>
                <h3 class="mt-1 text-xs font-bold">{{ $t('general.urgent_problem') }}</h3>
                <CFIcon
                    name="phone-actions-question"
                    size="20"
                    class="mt-5 mb-2"
                />
                <p class="text-center text-xs leading-snug">{{ $t('support.urgent_problem_description') }}*</p>
                <p class="text-2xs text-neutrals-700 mt-2 mb-2 text-center leading-snug">
                    *{{ $t('support.charges_may_apply') }}.
                </p>
                <p class="text-2xs text-neutrals-700 mb-3 text-center leading-snug">
                    {{ $t('support.not_available_for', { product: 'Hosting Plan Essential' }) }}
                </p>
                <CFButton
                    size="sm"
                    variant="outline"
                    type="button"
                    class="mt-auto"
                    @click="callPhoneNumber"
                >
                    {{ $t('general.call') }} {{ appConfig.supportPhoneNumber }}
                </CFButton>
            </div>

            <div class="col-span-2 bg-white">
                <div class="flex flex-wrap items-center gap-5 p-5">
                    <div class="shrink-0">
                        <CFIcon
                            name="file-code-information"
                            size="28"
                        />
                    </div>
                    <div class="grow">
                        <h3 class="mb-1 text-xs font-bold">{{ $t('support.documentation_title') }}</h3>
                        <p class="text-xs">{{ $t('support.documentation_description') }}</p>
                    </div>
                    <div class="shrink-0">
                        <CFButton
                            size="sm"
                            variant="outline"
                            type="button"
                            @click="goToDocumentation"
                        >
                            {{ $t('support.documentation_button') }}
                        </CFButton>
                    </div>
                </div>
            </div>
        </div>
    </CFTicketModalInner>
</template>
